import { LoggerInterface } from '@app/lib/logger/Contracts/LoggerInterface';

export class Logger {
    constructor(private readonly logger: LoggerInterface | null) {}

    logException(error: unknown): void {
        if (!(error instanceof Error)) {
            return;
        }

        this.logger?.logException(error);
    }

    logMessage(message: string): void {
        this.logger?.logMessage(message);
    }

    logJson(json: object): void {
        this.logger?.logJson(json);
    }
}
